import instance from "../interceptors/AxiosInterceptor";

const BASE_URL = "/api/contracts";
const contractService = {

    getContractsByUser: async () => {
        try {
            const response = await instance.get(`${BASE_URL}/all`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getContractsByDebtor: async (debtorId) => {
        try {
            const response = await instance.get(`${BASE_URL}/by-debtor/${debtorId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    addContract: async (contract) => {
        try {
            const response = await instance.post(`${BASE_URL}/add`, contract, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateContract: async (contractId, contract) => {
        try {
            const response = await instance.put(`${BASE_URL}/update/${contractId}`, contract, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    deleteContract: async (contractId) => {
        try {
            const response = await instance.delete(`${BASE_URL}/delete/${contractId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

}

export default contractService;